import { Injectable } from '@angular/core';
declare var DBObject:any

@Injectable()
export class IndexedDbStorageService {

  DBInstance
  DataBaseName="InfoviewSims"
  public getterValues
  constructor() { 
    
  }
  protected OnInit(){
    
  }

  async getStore(key){
   return new Promise<any>(async (resolve,reject)=>{
    let values='[]'
      const requestResponse=await  DBObject.transaction(this.DataBaseName,'readwrite').objectStore(this.DataBaseName).get(key)
      requestResponse.addEventListener('success',(red)=>{
        if(red.target.result){
          values=red.target.result
          this.getterValues=red.target.result
          resolve(values)
        }else{
          resolve(values)
        }
      })
    })
  }

  DestroyStore(){

  }

  async AddtoStore(key,v) {
    this.OnInit()
    if(DBObject){
      const isExist= await DBObject.transaction(this.DataBaseName,'readonly').objectStore(this.DataBaseName).get(key)
      if(isExist){
        const requestResponse=await  DBObject.transaction(this.DataBaseName,'readwrite').objectStore(this.DataBaseName).put(v,key)
        return requestResponse
      }else{
        const requestResponse=await  DBObject.transaction(this.DataBaseName,'readwrite').objectStore(this.DataBaseName).add(v,key)
        return requestResponse
      }

    }

    
  }

}



// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/indexed-db-storage.service.ts